import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePosts } from '@/hooks/usePosts';
import { DEFAULT_POST_IMAGE } from '@/config/constants';
import PostsPageView from './postspage.view';

const PostsPage = () => {
  const navigate = useNavigate();
  const { data: rawPosts = [], isLoading: loading } = usePosts();

  const posts = useMemo(() => rawPosts.map(post => ({
    id: post.id,
    title: post.title,
    excerpt: post.excerpt,
    content: post.content,
    image: post.image || DEFAULT_POST_IMAGE,
    author: post.author,
    date: post.publishDate?.split('T')[0] || ''
  })), [rawPosts]);

  return (
    <PostsPageView
      posts={posts}
      loading={loading}
      navigate={navigate}
    />
  );
};

export default PostsPage;
